module.exports = __webpack_public_path__ + "img/Calming Presence.bfc04902.svg";